var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 42,
    viewBox: "0 0 37 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0201 41.6212C19.5801 41.6212 15.7801 40.6212 12.6201 38.6212C9.46011 36.6212 7.30011 33.3212 6.14011 28.7212H0.800108V23.7412H5.36011C5.32011 23.2212 5.30011 22.3612 5.30011 21.1612C5.30011 19.9612 5.32011 19.0812 5.36011 18.5212H0.800108V13.5412H6.14011C7.30011 8.98117 9.46011 5.70117 12.6201 3.70117C15.8201 1.70117 19.6201 0.701171 24.0201 0.701171C27.9801 0.701171 32.1801 1.58117 36.6201 3.34117V10.8412C32.7401 9.04117 28.7201 8.14117 24.5601 8.14117C22.2401 8.14117 20.3001 8.58117 18.7401 9.46117C17.2201 10.3012 16.0601 11.6612 15.2601 13.5412H29.1801V18.5212H13.9401C13.8601 19.6412 13.8201 20.5212 13.8201 21.1612C13.8201 21.8412 13.8601 22.7012 13.9401 23.7412H29.1801V28.7212H15.2601C16.0601 30.6412 17.2201 32.0412 18.7401 32.9212C20.3001 33.7612 22.2401 34.1812 24.5601 34.1812C28.7201 34.1812 32.7401 33.2812 36.6201 31.4812V38.9812C32.1801 40.7412 27.9801 41.6212 24.0201 41.6212Z",
    fill: "#31B9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroIcon);
export default __webpack_public_path__ + "static/media/euro_icon.45fb895cd69360f5ac6f1d6205844bf6.svg";
export { ForwardRef as ReactComponent };